import React, { useState, useEffect } from 'react'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-hot-toast'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'

const UpdateTransaction = ({ transaction, setOpen }) => {
  console.log('transactionin upadte', transaction)

  const { transaction_id } = useParams() // Dynamic route param
  const navigate = useNavigate()
  const formatDate = (dateString) => {
    if (!dateString) return null // Handle null or undefined values
    return dateString.split(' ')[0] // Extract date part from "YYYY-MM-DD HH:mm:ss"
  }

  const getCurrentDate = () => {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const [transactionData, setTransactionData] = useState({
    payment_method: transaction.payment_method,
    online_transaction_number: transaction.online_transaction_number || '',
    transaction_amount: transaction.transaction_amount,
    transaction_date:
      formatDate(transaction.transaction_date) || getCurrentDate(),
    transaction_managed_by: transaction.transaction_managed_by,
    transaction_amount_in_words: '',
  })

  const [loading, setLoading] = useState(false)

  // Convert number to words
  const convertNumberToWords = (num) => {
    const ones = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
    ]
    const teens = [
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ]
    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ]
    const thousands = ['', 'Thousand', 'Lakh', 'Crore']

    if (num === 0) return 'Zero Only'
    let words = ''

    const convertHundreds = (n) => {
      if (n < 10) return ones[n]
      if (n < 20) return teens[n - 10]
      if (n < 100) {
        return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '')
      }
      return (
        ones[Math.floor(n / 100)] +
        ' Hundred' +
        (n % 100 ? ' ' + convertHundreds(n % 100) : '')
      )
    }

    const crore = Math.floor(num / 10000000)
    const lakh = Math.floor((num % 10000000) / 100000)
    const thousand = Math.floor((num % 100000) / 1000)
    const remainder = num % 1000

    if (crore) words += convertHundreds(crore) + ' Crore '
    if (lakh) words += convertHundreds(lakh) + ' Lakh '
    if (thousand) words += convertHundreds(thousand) + ' Thousand '
    if (remainder) words += convertHundreds(remainder)

    return words.trim() + ' Only'
  }

  // Update transaction amount in words when amount changes
  useEffect(() => {
    setTransactionData((prevData) => ({
      ...prevData,
      transaction_amount_in_words: convertNumberToWords(
        Number(prevData.transaction_amount) || 0,
      ),
    }))
  }, [transactionData.transaction_amount])

  // Handle payment method change
  const handlePaymentMethodChange = (e) => {
    const selectedMethod = e.target.value

    setTransactionData((prevData) => ({
      ...prevData,
      payment_method: selectedMethod,
      online_transaction_number:
        selectedMethod === 'CASH' ? '' : transaction.online_transaction_number,
    }))
  }
  // Handle form input changes
  const inputHandler = (e) => {
    setTransactionData({
      ...transactionData,
      [e.target.name]: e.target.value, // Update the state with the new date
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const token = Cookies.get('authToken')
    if (!token) {
      alert('Authentication required. Please log in.')
      setLoading(false)
      return
    }

    const payload = {
      ...transactionData,
      id: transaction_id,
    }

    try {
      const response = await axios.put(
        BASE_URL+`/update/transaction/${transaction.id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )

      if (response) {
        // Show success toast first
        toast.success(response.data.message)

        // Delay navigation to allow the toast to be visible
        setTimeout(() => {
          window.location.reload()
          navigate('/bookingtransactionlists')
        }, 1500) // Adjust the delay as needed (1500ms = 1.5 seconds)
      } else {
        setTimeout(() => {
          toast.success(response.data.message)
        }, 1000)
      }
    } catch (error) {
      if (error) {
        toast.error(error.response?.data?.message)
        setTimeout(() => {
          window.location.reload()
          navigate('/bookingtransactionlists')
        }, 1500)
      } else {
        setTimeout(() => {
          toast.error(error.response?.data?.message)
        }, 1500)
      }
    } finally {
      setLoading(false)
    }
  }

  const handleBack = () => {
    setOpen(false)
  }
  return (
<Container className="pb-3" style={{fontFamily: theme.font.family }}>
      <Form className="text-start px-3" onSubmit={handleSubmit} style={{backgroundColor:theme.colors.background, color: theme.colors.primary}}>

        <div className='d-flex justify-content-start p-2 mb-2' style={{cursor: 'pointer',alignItems:'center' }} onClick={handleBack}>
          <i class="fa-solid fa-arrow-left" style={{color:theme.colors.primary}}></i>
          <span className='ms-2'> Back to Transaction List</span>
        </div>
         <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary} `, paddingBottom: '8px' , fontSize: '1.5rem'}}>
          Edit Transaction for Booking ID - {transaction.booking_id}          
          </p>


        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="transactionid">Transaction ID</Form.Label>
            <Form.Control id="transactionid" value={transaction.id} disabled />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="payment_method">Payment Method</Form.Label>
            <Form.Select
              id="payment_method"
              name="payment_method"
              value={transactionData.payment_method}
              onChange={handlePaymentMethodChange}
            >
              <option value="">SELECT</option>
              <option value="CASH">CASH</option>
              <option value="ONLINE">ONLINE</option>
              <option value="CHEQUE">CHEQUE</option>
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="online_transaction_number">
              {transactionData.payment_method === 'CASH'
                ? 'Not Mandatory'
                : transactionData.payment_method === 'CHEQUE'
                ? 'Cheque Number *'
                : 'Online Transaction Number *'}
            </Form.Label>
            <Form.Control
              type="text"
              id="online_transaction_number"
              name="online_transaction_number"
              value={transactionData.online_transaction_number || ''}
              onChange={inputHandler}
              placeholder={
                transactionData.payment_method === 'CASH'
                  ? 'N/A'
                  : transactionData.payment_method === 'CHEQUE'
                  ? 'Enter Cheque Number'
                  : 'Enter Transaction Number'
              }
              disabled={transactionData.payment_method === 'CASH'}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="transaction_date">Transaction Date</Form.Label>
            <Form.Control
              type="date"
              id="transaction_date"
              name="transaction_date"
              value={transactionData.transaction_date} // Display current or default date
              onChange={inputHandler} // Update date on change
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="transaction_amount">
              Transaction Amount
            </Form.Label>
            <Form.Control
              id="transaction_amount"
              name="transaction_amount"
              value={transactionData.transaction_amount}
              onChange={inputHandler}
            />
          </Col>
          <Col md={12} className="mb-3">
            <Form.Label htmlFor="transaction_amount_in_words">
              Transaction Amount in Words
            </Form.Label>
            <Form.Control
              as="textarea"
              id="transaction_amount_in_words"
              name="transaction_amount_in_words"
              value={transactionData.transaction_amount_in_words}
              disabled
            />
          </Col>
        </Row>
        <div className="d-grid mt-4">
          <Button
            type="submit"
            // onClick={handleUpdateButton}
            style={{ backgroundColor: theme.colors.primary, border: 'none', color : theme.colors.background }}
          >
            {loading ? 'Editing...' : 'Edit Transaction'}
          </Button>
        </div>
      </Form>
    </Container>
  )
}

export default UpdateTransaction
